<template>
  <!-- 这个页面直接复制了登录之前的修改密码页面，稍作修改 -->
  <div>
    <div class="card_wraper register_wrap">
      <div class="register_title">
        <span class="title">修改密码</span>
        <a @click="configReturnBtnHandle" class="go_login">
          退出登录
        </a>
      </div>
      <div class="info_wrap">
        <div class="info_input">
          <img
            src="~assets/img/register/shouji_number.png"
            alt
            class="img_input"
          />
          <!-- 修改1  禁用了手机输入框  并把禁用之后的背景色改成无 -->
          <input
            type="text"
            class="input_text"
            placeholder="请输入电话号码"
            v-model="registerSubmitData.telePhone"
            onkeyup="this.value=this.value.replace(/\D/g,'')"
            onafterpaste="this.value=this.value.replace(/\D/g,'')"
            disabled
            style="background:none"
          />
        </div>

        <div class="info_input">
          <img
            src="~assets/img/register/shouji_mima.png"
            alt
            class="img_input"
          />
          <input
            type="password"
            class="input_text"
            placeholder="请输入老密码"
            v-model="registerSubmitData.oldPassword"
            autocomplete="new-password"
            onkeyup="value=value.replace(/[\u4e00-\u9fa5]/ig,'')"
          />
          <!-- 禁止输入中文 onkeyup="value=value.replace(/[\u4e00-\u9fa5]/ig,'')-->
        </div>

        <div class="info_input">
          <img
            src="~assets/img/register/shouji_queren.png"
            alt
            class="img_input"
          />
          <input
            type="password"
            class="input_text"
            placeholder="请输入新密码"
            v-model="registerSubmitData.newPassword"
            autocomplete="new-password"
            onkeyup="value=value.replace(/[\u4e00-\u9fa5]/ig,'')"
          />
        </div>
        <div class="info_input">
          <img
            src="~assets/img/register/shouji_queren.png"
            alt
            class="img_input"
          />
          <input
            type="password"
            class="input_text"
            placeholder="请再次输入新密码"
            v-model="registerSubmitData.CnewPassword"
            autocomplete="new-password"
            onkeyup="value=value.replace(/[\u4e00-\u9fa5]/ig,'')"
          />
        </div>
      </div>

      <div class="register_btn" @click="changeSubmitHandle">确定修改</div>
    </div>
  </div>
</template>

<script>
//公用函数
import {
  countSHandle,
  checkCallphoneCrc,
  checkUserDataChangePassword,
  checkPassword,
  checkPasswordC
} from 'common/beforeLogin/RegisterPage'

export default {
  name: 'MChangePassword',
  components: {},
  data() {
    return {
      registerSubmitData: {
        ////  子用户修改密码数据
        telePhone: '', //账号
        oldPassword: '', //老密码
        newPassword: '', //新密码
        CnewPassword: '' //再次新密码
      }
    }
  },
  computed: {},
  methods: {
    changeSubmitHandle() {
      // 判断输入信息条件
      if (this.registerSubmitData.oldPassword === '') {
        this.$toast('老密码不能为空！')
        return
      }
      if (!checkPassword(this.registerSubmitData.newPassword)) return
      if (
        !checkPasswordC(
          this.registerSubmitData.newPassword,
          this.registerSubmitData.CnewPassword
        )
      )
        return
      // 子账号修改密码
      this.$request({
        method: 'post',
        url: '/user/updateSubPwd',
        data: {
          token: this.$store.state.token,

          oldPwd: this.registerSubmitData.oldPassword,
          newPwd: this.registerSubmitData.newPassword
        }
      })
        .then(res => {
          console.log(res)
          if (res.data.code != 0) {
            this.$toast(res.data.message, 5000) ///服务端返回信息
            ////说明信息填写错误
            return
          } else {
            this.$store.dispatch(
              'asyUpdataUserId',
              this.registerSubmitData.telePhone
            ) ///异步提交用户的账号信息到仓库
            // this.$router.replace('/') ///说明注册成功，返回到登陆页面
            this.configReturnBtnHandle() ////清空账号信息
            this.$showTipsToast(1, '修改成功', true) ////提示框
            this
          }
        })
        .catch(err => {
          console.log(err)
        })
      // this.$store.dispatch('asyUpdataUserId',this.registerSubmitData.telePhone); ///异步提交用户的账号信息到仓库
      // this.$toast("注册成功！",5000);  ///服务端返回信息
      // this.$router.replace('/'); ///说明注册成功，返回到登陆页面
    },
    configReturnBtnHandle() {
      ////退出登录按钮
      console.log('退出登录')
      sessionStorage.clear() //清空浏览器缓存token
      this.$store.dispatch('asyUpdataToken', '') ///清空vuex里面的token
      this.$router.replace('/login')
    }
  },
  created() {
    /////
    this.registerSubmitData.telePhone = sessionStorage.getItem('account')
  },
  mounted() {
    //vue实例挂载完成，data.filter成功渲染  一般数据请求放在这里
    // this.rquestServerImgCheck() ///请求新的图片验证码
  }
}
</script>

<style>
/* 注册页面 修改密码页面  修改主账号密码页面  修改子账号密码页面共用样式 */
</style>
